import { GET_NB_SESSIONS_DONE, GET_ONE_SIGNAL_TAGS } from '../../queries/User';
import { captureException } from '@sentry/react-native';
import { client } from '../../../config/apollo/client';
import { flow, types } from 'mobx-state-tree';

export const StatModel = types.model('StatModel', {
  nbSessionsDone: types.maybeNull(types.number),
  number_of_path_started: types.maybeNull(types.number),
  number_of_path_completed: types.maybeNull(types.number),
}).actions(self => {

  const fetchNbSessionsDone = flow(function* () {
    try {
      const { data }: any = yield client.query({ query: GET_NB_SESSIONS_DONE, fetchPolicy: 'no-cache' });
      if (data?.getMyProfile?.nbSessionsDone) {

        self.nbSessionsDone = data.getMyProfile.nbSessionsDone;
      }
    } catch (error) {
      captureException(error);
      return null;
    }
  });

  const incrementNumberOfSessionsDone = () => {
    if(self.nbSessionsDone !== null) {
      self.nbSessionsDone++;
    } else {
      self.nbSessionsDone =1;
    }
  };


  const fetchOneSignalTags = flow(function* () {
    try {
      const { data }: any = yield client.query({ query: GET_ONE_SIGNAL_TAGS, fetchPolicy: 'no-cache' });
      if (data && data.fetchOneSignalTags) {
        self.number_of_path_started = Number(data.fetchOneSignalTags.number_of_path_started);
        self.number_of_path_completed = Number(data.fetchOneSignalTags.number_of_path_completed);
      }
    } catch (error) {
      captureException(error);
      return null;
    }
  });
  const incrementNumberOfPathStarted = () => {
    if(!self.number_of_path_started) {
      self.number_of_path_started = 1;
    } else {
      self.number_of_path_started++;
    }
  };
  return {
    fetchNbSessionsDone,
    incrementNumberOfSessionsDone,
    fetchOneSignalTags,
    incrementNumberOfPathStarted
  };
});

